export default __webpack_public_path__ + "static/media/heart-outline.8f59db7e.svg";